import useCrmStore from '../stores/crmStore';
import useAuthStore from '../stores/authStore';
import { useEffect } from 'react';
import { Phone, Users, Trophy, XCircle, TrendingUp } from 'lucide-react';
import PausePanel from './PausePanel';

export default function Topbar({ title, subtitle }) {
  const metrics = useCrmStore(s => s.metrics);
  const fetchMetrics = useCrmStore(s => s.fetchMetrics);
  const userRole = useAuthStore(s => s.user?.role);

  useEffect(() => {
    fetchMetrics();
    const id = setInterval(fetchMetrics, 30000);
    return () => clearInterval(id);
  }, [fetchMetrics]);

  // Gerente keeps the Topbar minimal — the dashboard already shows consolidated KPIs.
  const showPills = userRole !== 'gerente';

  const pills = [
    { label: 'Total Leads', value: metrics?.total_leads ?? '-', icon: Users, color: 'blue' },
    { label: 'Ganados', value: metrics?.ganados ?? '-', icon: Trophy, color: 'green' },
    { label: 'Perdidos', value: metrics?.perdidos ?? '-', icon: XCircle, color: 'red' },
    { label: 'Conversión', value: metrics?.conversion != null ? `${metrics.conversion}%` : '-', icon: TrendingUp, color: 'amber' },
    { label: 'Llamadas hoy', value: metrics?.llamadas_hoy ?? '-', icon: Phone, color: 'purple', live: true },
  ];

  return (
    <div data-testid="topbar" className="topbar">
      <div className="topbar-left">
        <h1 className="topbar-title">{title}</h1>
        {subtitle && <p className="topbar-subtitle">{subtitle}</p>}
      </div>
      {/* Pause panel renders only for asesor (PausePanel checks user role internally) */}
      <PausePanel />
      {showPills && (
        <div className="topbar-metrics" data-testid="topbar-metrics">
          {pills.map(p => {
            const Icon = p.icon;
            return (
              <div key={p.label} className={`tpill tpill-${p.color}`} data-testid={`metric-${p.label.toLowerCase().replace(/\s/g, '-')}`}>
                <Icon size={14} />
                <span className="tpill-value">{p.value}</span>
                <span className="tpill-label">{p.label}</span>
                {p.live && <span className="live-dot" />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
